/**
 * Question model with transformation utilities
 */

/**
 * Transform API question data to internal format
 * @param {Object} apiQuestion - Question data from API
 * @param {string} language - Language code for translations
 * @returns {Object} Transformed question
 */
export function transformQuestion(apiQuestion, language = "fr") {
  if (!apiQuestion) {
    return null;
  }

  // Find the best translation for the current language
  const translations = apiQuestion.questionTranslations || [];
  const translation = translations.find((t) => t.language?.code === language)
  if (!translation) return null;

  return {
    id: apiQuestion.id,
    createdAt: apiQuestion.createdAt,
    updatedAt: apiQuestion.updatedAt,
    deletedAt: apiQuestion.deletedAt,
    userId: apiQuestion.user?.id,
    enonce: translation?.questionText || "",
    public: false, // Default value, may need to be added to API
    themeId: apiQuestion.themeId || apiQuestion.theme?.id || null, // Support both themeId and theme.id
    translations: translations.map((t) => ({
      language: t.language?.code,
      questionText: t.questionText,
      deletedAt: t.deletedAt,
    })),
  };
}

/**
 * Transform internal question data to API format
 * @param {Object} question - Internal question data
 * @returns {Object} API-formatted question
 */
export function transformQuestionToApi(question) {
  if (!question) {
    return null;
  }

  return {
    id: question.id,
    userId: question.userId,
    themeId: question.themeId,
    public: question.public,
    questionTranslations:
      question.translations?.map((t) => ({
        language: { code: t.language },
        questionText: t.questionText,
      })) || [],
  };
}
